module.exports = __webpack_public_path__ + "static/media/audio.94420770.png";